import { DirtyOutKeyItemDataKey } from './dirty-out-key-item.model';

export class DirtyOutTask {
  public action: string;
  public sync_id: number;
  public sharetype: number;
  public share_id: number;
  public share_sequence: number;

  public share_key?: string;
  public enc_share_name?: string;

  public blob_id: number;
  public blob_ids: number[];

  public keys: DirtyOutKeyItemDataKey[];
}

export class DirtyOutTaskResult {
  public action: 'encdatakey' | 'encnameshare';
  public sync_id: number;
  public share_id: number;
  public share_sequence: number;
}

export class DirtyOutTaskDataKeyResult extends DirtyOutTaskResult {
  public blob_id;
  public enc_data_key: string;
}

export class DirtyOutTaskShareNameResult extends DirtyOutTaskResult {
  public enc_share_name;
}
